import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import AccountService from 'wanderu-service-account';
import { SnowplowService } from 'wanderu-service-analytics';

import { actions } from './base';
import { actions as userInfoActions } from '../../appstate/userInfo';

const logger = Logger.getLogger('wanderu-ducks-account');

function reset() {
    return actions.reset();
}

function update(billingAddress) {
    return async (dispatch) => {
        dispatch(actions.startWork());

        let meta;
        let error;
        try {
            const updatedBillingInfo = await AccountService.saveUserInfo(billingAddress);

            return dispatch(userInfoActions.updateBillingAddress(updatedBillingInfo));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('updateBillingAddress', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(meta, error));
        }
    };
}

export {
    reset,
    update,
};
